import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { useCallback } from 'react';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

import { IDecisionFormRef } from '../../../DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmErknmEventSubmittedDocumentsForm } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmEventSubmittedDocumentsForm';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { KnmEventsDocumentItem } from './KnmEventsDocumentItem';

interface IKnmEventsDocumentsProps {
  baseId?: string;
  eventFieldName: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  isDecision?: boolean;
  isFilledFromLink?: boolean;
  isKnm?: boolean;
  isPm?: boolean;
  isSubmissionWatchOnly?: boolean;
  isWatchOnly: boolean;
  sIndex: number;
  startDateEvent?: string;
  stopDateEvent?: string;
}

export const KnmEventsDocuments = ({
  baseId,
  eventFieldName,
  formRef,
  isDecision,
  isFilledFromLink,
  isKnm,
  isPm,
  isSubmissionWatchOnly,
  isWatchOnly,
  sIndex,
  startDateEvent,
  stopDateEvent,
}: IKnmEventsDocumentsProps) => {
  const push = formRef?.current.mutators.push;

  /**
   * Функция добавления объекта-документа
   */
  const addEventDocument = useCallback(
    (fieldName: string) => {
      if (isWatchOnly || !push) {
        return;
      }

      const addingDoc: IKnmErknmEventSubmittedDocumentsForm = {
        status: {
          code: 'SD-2',
          id: 2,
          weight: 2,
          label: 'Не представлен',
          title: 'Не представлен',
          value: 'SD-2',
        },
        isNew: true,
        guid: null,
      };

      push(`${fieldName}.submittedDocuments`, addingDoc);
    },
    [push, isWatchOnly],
  );

  return (
    <FieldBlock
      label={getTitleFieldWithRedStar({
        label: 'Представляемые контролируемым лицом документы',
        field: `${eventFieldName}.submittedDocuments`,
        isDecision,
        isKnm,
        isPm,
      })}
      button={
        <Button
          className="shared-btn-add"
          text="Добавить"
          variant="link"
          color="primary"
          type="button"
          id="erknmEventsDocumentsAddButton"
          disabled={isWatchOnly}
          onClick={() => addEventDocument(eventFieldName)}
        />
      }
    >
      <FieldArray name={`${eventFieldName}.submittedDocuments`}>
        {(documentsArray: FieldArrayRenderProps<IKnmErknmEventSubmittedDocumentsForm, HTMLElement>) => {
          if (!documentsArray.fields.length) {
            return null;
          }

          return documentsArray.fields.map((docFieldName, jIndex) => {
            const fieldValueDocument = documentsArray.fields.value?.[jIndex];

            const statusId = fieldValueDocument.status?.id;

            return (
              <KnmEventsDocumentItem
                key={fieldValueDocument.guid || `knm-events-submitted-document-${jIndex}`}
                docFieldName={docFieldName}
                eventFieldName={eventFieldName}
                fieldValueDocument={fieldValueDocument}
                formRef={formRef}
                isWatchOnly={isWatchOnly}
                isSubmissionWatchOnly={isSubmissionWatchOnly ?? isWatchOnly}
                jIndex={jIndex}
                sIndex={sIndex}
                baseId={baseId}
                isDecision={isDecision}
                isKnm={isKnm}
                isPm={isPm}
                statusId={statusId}
                startDateEvent={startDateEvent}
                stopDateEvent={stopDateEvent}
                isFilledFromLink={isFilledFromLink === true}
              />
            );
          });
        }}
      </FieldArray>
    </FieldBlock>
  );
};
